import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IWebhook,
    IWebhookEventTypeDto,
    ODataResponse,
    TreeDataGroup,
} from '@models';
import { MapperService } from '@services/mapper.service';

import {
    Observable,
} from 'rxjs';
import {
    map,
} from 'rxjs/operators';

import { ODataService } from './generics/odata.service';

interface IODataArray<T> {
    value: Array<T>;
}

interface IHostAvailibility {
    canConnect: boolean | null;
    hasBadSsl: boolean | null;
    connectionError: string | null;
}

@Injectable()
export class WebhookService extends ODataService<IWebhook, number> {
    protected _endpoint = '/odata/Webhooks';

    constructor(
        http: HttpClient,
    ) {
        super(http, MapperService.webhookMap);
    }

    public getEventTypeGroups(): Observable<TreeDataGroup[]> {
        return this._http.get<IODataArray<IWebhookEventTypeDto>>(`${this._endpoint}/UiPath.Server.Configuration.OData.GetEventTypes`)
            .pipe(
                map(response => this._mapData(response, MapperService.webhookEventTypeMap) as ODataResponse<IWebhookEventTypeDto>),
                map(response =>
                    // we map only one-level groups because that's what we get from the server
                    response.data.reduce(
                        (accumulator, current) => {
                            const group = accumulator.find(obj => Object.keys(obj).includes(current.group));

                            if (group) {
                                (group[current.group] as string[]).push(current.name);
                            } else {
                                accumulator.push({
                                    [current.group]: [current.name],
                                });
                            }

                            return accumulator;
                        }, [] as TreeDataGroup[],
                    ).sort((a, b) => {
                        const [aKey] = Object.keys(a);
                        const [bKey] = Object.keys(b);

                        return (b[bKey] as string[]).length -
                            (a[aKey] as string[]).length;
                    }),
                ),
            );
    }

    public verifyHost(url: string): Observable<IHostAvailibility> {
        return this._http.get<IHostAvailibility>(`/api/Status/VerifyHostAvailibility?url=${url}`);
    }

    public toggleEnabled(webhook: IWebhook) {
        return this.patch(webhook.id, { enabled: webhook.enabled });
    }
}
